import { db } from '@/firebase';
import { collection, getDocs, addDoc, updateDoc, deleteDoc, doc } from 'firebase/firestore';

export default {
  namespaced: true,
  state: {
    risks: [],
    loading: false,
    error: null
  },
  mutations: {
    SET_RISKS(state, risks) {
      state.risks = risks;
    },
    SET_LOADING(state, loading) {
      state.loading = loading;
    },
    SET_ERROR(state, error) {
      state.error = error;
    },
    ADD_RISK(state, risk) {
      state.risks.push(risk);
    },
    UPDATE_RISK(state, updatedRisk) {
      const index = state.risks.findIndex(risk => risk.id === updatedRisk.id);
      if (index !== -1) {
        state.risks.splice(index, 1, updatedRisk);
      }
    },
    DELETE_RISK(state, riskId) {
      state.risks = state.risks.filter(risk => risk.id !== riskId);
    }
  },
  actions: {
    async fetchRisks({ commit }) {
      commit('SET_LOADING', true);
      commit('SET_ERROR', null);
      try {
        const risksCollection = collection(db, 'risks');
        const risksSnapshot = await getDocs(risksCollection);
        const risks = risksSnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
        commit('SET_RISKS', risks);
      } catch (error) {
        console.error('Error fetching risks:', error);
        commit('SET_ERROR', error.message);
      } finally {
        commit('SET_LOADING', false);
      }
    },
    async addRisk({ commit }, riskData) {
      commit('SET_LOADING', true);
      commit('SET_ERROR', null);
      try {
        const risksCollection = collection(db, 'risks');
        const docRef = await addDoc(risksCollection, riskData);
        const newRisk = {
          id: docRef.id,
          ...riskData
        };
        commit('ADD_RISK', newRisk);
        return newRisk;
      } catch (error) {
        console.error('Error adding risk:', error);
        commit('SET_ERROR', error.message);
        throw error;
      } finally {
        commit('SET_LOADING', false);
      }
    },
    async updateRisk({ commit }, { id, data }) {
      commit('SET_LOADING', true);
      commit('SET_ERROR', null);
      try {
        const riskRef = doc(db, 'risks', id);
        await updateDoc(riskRef, data);
        const updatedRisk = {
          id,
          ...data
        };
        commit('UPDATE_RISK', updatedRisk);
        return updatedRisk;
      } catch (error) {
        console.error('Error updating risk:', error);
        commit('SET_ERROR', error.message);
        throw error;
      } finally {
        commit('SET_LOADING', false);
      }
    },
    async deleteRisk({ commit }, riskId) {
      commit('SET_LOADING', true);
      commit('SET_ERROR', null);
      try {
        const riskRef = doc(db, 'risks', riskId);
        await deleteDoc(riskRef);
        commit('DELETE_RISK', riskId);
      } catch (error) {
        console.error('Error deleting risk:', error);
        commit('SET_ERROR', error.message);
        throw error;
      } finally {
        commit('SET_LOADING', false);
      }
    }
  },
  getters: {
    getRisks: state => state.risks,
    isLoading: state => state.loading,
    getError: state => state.error,
    getRisksByCategory: state => category => {
      return state.risks.filter(risk => risk.category === category);
    },
    getRisksByImpact: state => impact => {
      return state.risks.filter(risk => risk.impact === impact);
    },
    getRiskCategories: state => {
      return [...new Set(state.risks.map(risk => risk.category))];
    },
    getRiskImpactDistribution: state => {
      const distribution = {
        High: 0,
        Medium: 0,
        Low: 0
      };
      state.risks.forEach(risk => {
        distribution[risk.impact]++;
      });
      return distribution;
    }
  }
}; 